<rap-add-edit-user-ui [editableUser]="editableUser$ | async" [roles]="roles$ | async" [rosters]="rosters$ | async"
    [title]="title" (createNewUserEmitter)="createNewUser($event)"
    (updateUserEmitter)="updateUser($event)"></rap-add-edit-user-ui>